// Swiper 初期化（そのままでOK）
const swiper = new Swiper('.js-swiper', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  preventClicks: false,
  preventClicksPropagation: false,
  autoplay: {
    delay: 6000,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
});

const swiperSp = new Swiper('.js-swiper-sp', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 'auto',
  preventClicks: false,
  preventClicksPropagation: false,
  autoplay: {
    delay: 6000,
  },
  pagination: {
    el: '.swiper-pagination',
  }
});

// ✅ 閲覧済みリンクに .viewed をつける処理（関数化）
function markViewedLinks() {
  const productLinks = document.querySelectorAll("a.product-link");
  const spfLinks = document.querySelectorAll('a[href^="/products/"]');

  productLinks.forEach(link => {
    const key = "viewed_" + link.href;
    if (localStorage.getItem(key)) {
      link.classList.add("viewed");
    }
    link.addEventListener("click", () => {
      localStorage.setItem(key, "true");
    });
  });

  spfLinks.forEach(link => {
    const key = "viewed_" + link.href;
    if (localStorage.getItem(key)) {
      link.closest('.spf-product-card__title')?.classList.add("viewed");
    }
    link.addEventListener("click", () => {
      localStorage.setItem(key, "true");
    });
  });
}

// ✅ 初期実行（遅延読み込み対策）
setTimeout(markViewedLinks, 1000);

// ✅ 戻るボタンでも再判定
window.addEventListener("pageshow", markViewedLinks);
